<template>
  <div class="information-background">
    <div class="information-header container">
      <cms-block
        :identifier="'header-first-time-info'"
      />
    </div>
  </div>
</template>

<script>
import CmsBlock from 'theme/components/core/blocks/Cms/Block'

export default {
  components: {
    CmsBlock
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import "~theme/css/variables/grid";

.information-header {
  font-size: 18px;
  line-height: 32px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}

@include desktop {
  .information-header {
    padding: 6px 85px;
  }
}

@include tablet {
  .information-header {
    padding: 6px 20px;
  }
}

@include mobile {
  .information-header {
    font-size: 14px;
    line-height: 18px;
    padding: 10px 20px;
    padding-right: 52px;
  }
}

</style>
